function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

let wasAudioMuted = true;
let wasPLaying = true;

const addBgVideoTogglers = function () {
  const videos = document.querySelectorAll('.embededVideo');

  if (!videos) return;

  // Mute video on scroll

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.01,
  };

  videos.forEach((video) => {
    const controlBtns = video.closest('.section-wrapper').querySelector('.ButtonGroup--controlers');
    if (!controlBtns) return;
    const observer = new IntersectionObserver((e) => {
      if (!e[0].isIntersecting) {
        wasPLaying = !video.paused;
        wasAudioMuted = video.muted;

        video.pause();
        controlBtns.classList.remove('Btn_unmute');
        return;
      };

      video.muted = wasAudioMuted;
      if (!wasPLaying) return;
  
      video.play();
      controlBtns.classList.add('Btn_unmute');
    }, options);

    controlBtns.addEventListener('click', (e) => {
      const iconType = e.target.closest('button')
        .querySelector('svg')
        .getAttribute('data-type');

      if (iconType === 'pause' || iconType === 'resume') {
        video[
          controlBtns.classList.contains('Btn_pause')
            ? 'play'
            : 'pause'
        ]();
        controlBtns.classList.toggle('Btn_pause');
      }

      if (iconType === 'mute' || iconType === 'unmute') {
        video.muted = controlBtns.classList.contains('Btn_unmute')
        video.volume = controlBtns.classList.contains('Btn_unmute') ? 0 : 1;
        controlBtns.classList.toggle('Btn_unmute');
      }
    });

    observer.observe(video);
  });
};

const videoSourceSetter = function () {
  if (!window.BackgroundVideoSetting) return;
  Object.entries(window.BackgroundVideoSetting).forEach(([k, v]) => {
    const isMobile = window.matchMedia('(max-width: 750px)').matches;
    const video = document.querySelector(`#shopify-section-${k} video`);
    const mobileVideo = v.mobile;
    const desktopVideo = v.desktop;

    video.src = isMobile ? mobileVideo : desktopVideo;
  });
};

const toggleLongVideo = function () {
  if (!window.BackgroundVideoSetting) return;
  const isMobile = window.matchMedia('(max-width: 750px)').matches;
  Object.entries(window.BackgroundVideoSetting).forEach(([k, v]) =>{
    const watchBtn = document.querySelector(`#shopify-section-${k} .Button-watch`)
    if (!watchBtn) return
    const longVideo = document.querySelector(`#shopify-section-${k} .long-video video`)
    const container = document.querySelector(`#shopify-section-${k} .main-wrapper`)
    const bgVideo = document.querySelector('.section-bg')
    watchBtn.addEventListener('click', e => {
      e.preventDefault();
      container.classList.add('playing')
      bgVideo.style.display = 'none'
      longVideo.scrollIntoView({behavior: "smooth", block: `${isMobile ? "center" : "end"}`})
      if (!iOS) longVideo.requestFullscreen()
      longVideo.play()
    })
    const hideLongVideo = function (sectionId) {
      const closeBtn = document.querySelector(`#shopify-section-${sectionId} .closeBtn_wrapper .Icon.Icon--close`)
      closeBtn.addEventListener('click', e => {
        container.classList.remove('playing')
        bgVideo.style.display = 'block'
        longVideo.pause()
        longVideo.currentTime = 0;
      })
    }
    hideLongVideo(k)
  })
  
}



export default () => {
  videoSourceSetter();
  addBgVideoTogglers();
  toggleLongVideo();
};
